import { MapaIndicadores } from "../../../assets/MapaIndicadores";
import homeIndicatorsBgUrl from "../../../assets/images/home-indicators-bg.png";
import IndicatorsBand from "../../IndicatorsBand/IndicatorsBand";
import { getImageUrl } from "../../../utils/media";

// Fallback enquanto o backend nao retorna nada
const FALLBACK_INDICATORS = [
  { value: "4", description: "cidades atendidas" },
  { value: "+300", description: "atendidos" },
  { value: "+1200", description: "pessoas impactadas" },
];

export default function Indicadores({ section, indicators: indicatorsProp }) {
  const titulo = section?.title || "Nossos indicadores";
  const imageUrl = getImageUrl(section?.imageUrl) || homeIndicatorsBgUrl;
  const indicators = indicatorsProp?.length
    ? indicatorsProp
    : FALLBACK_INDICATORS;
  const normalizedIndicators = indicators.map((item) => ({
    ...item,
    label: item.label || item.description,
    description: item.label ? item.description : "",
  }));

  return (
    <IndicatorsBand
      title={titulo}
      imageUrl={imageUrl}
      indicators={normalizedIndicators}
      decoration={<MapaIndicadores />}
      showOverlay={false}
    />
  );
}
